import { type ReactNode } from 'react'

import { type TypeSeoMetadataEntry } from '@contentful-types/seo-metadata'
import { type TypeSocialMetadataEntry } from '@contentful-types/social-metadata'

import { PageContext, type PageContextType } from '@contexts/page-context'
import { PageHeaderProvider } from '@contexts/page-header-context'

import { ShPageScripts } from '@components/page-core/scripts'
import { PageHead } from '@components/page-head'

export interface PageShellProps {
  children: ReactNode
  pageContext: PageContextType
  metadata: {
    social?: TypeSocialMetadataEntry
    seo?: TypeSeoMetadataEntry
  }
  heroImageSeed?: number | null
}

export function PageShell({ children, pageContext, metadata, heroImageSeed }: PageShellProps) {
  return (
    <>
      <PageContext.Provider value={pageContext}>
        <ShPageScripts enableLegacyTracking enableGtmIntegration />
        <PageHead
          seoMetadata={metadata?.seo}
          socialMetadata={metadata?.social}
          heroImageSeed={heroImageSeed}
        />
        <PageHeaderProvider>{children}</PageHeaderProvider>
      </PageContext.Provider>
    </>
  )
}
